import { getAcademyUrlPublic, getAppMarketplaceUrl, getCMSUrlPublic, getCommerceUrlPublic, getCommunityUrlPublic, getDevelopersAndApiDocsBaseUrl, getDevelopersApiDocsUrl, getDevelopersQuickStartGuideUrl, getKBEmbedCTAUrlPublic, getKBImportToolUrlPublic, getKBMembershipsUrlPublic, getKBShareFormsUrlPublic, getKBStripeCurrencyUrlPublic, getKBTrackingCodeUrlPublic, getKnowledgeBaseUrlPublic, getLanguagesUrlPublic, getMarketingUrlPublic, getMembershipsExamplesUrl, getMicrositesExamplesUrl, getNonprofitsUrlPublic, getOperationsSupportedApplicationsUrl, getOperationsUrlPublic, getProductAndServicesUrlPublic, getSalesUrlPublic, getSecurityAndComplianceUrl, getServiceUrlPublic, getSolutionsMarketplaceUrl, getStartupsUrlPublic, getTemplatesMarketplaceUrl, getWebsiteMigrationUrlPublic } from 'pricing-pages-lib/utils/publicPageUrls';
import { STRIPE_GLOBAL_AVAILABILITY_URL, STRIPE_SUPPORT_URL, getCreateABundleUrl, getProductsAndServicesCatalogUrl } from 'pricing-pages-lib/utils/urls';
import { getClickedLinkEvent } from '../../utils/event-tracking/interactions';
import { trackEvent } from '../../utils/event-tracking/track-event';
import { NavItemEnum } from '../routing/NavItems';
import { LOCATIONS } from '../tracking/Locations';
export const FaqsConfig = {
  [NavItemEnum.MARKETING]: [{
    questionKey: 'marketing.whatIsMarketing411',
    getHref: () => getMarketingUrlPublic()
  }, {
    questionKey: 'marketing.whatAreMarketingContacts'
  }, {
    questionKey: 'marketing.howManyContacts411',
    isExternalLink: false,
    getHref: () => {
      return getCreateABundleUrl(false);
    }
  }, {
    questionKey: 'marketing.howManyEmails411'
  }, {
    questionKey: 'marketing.requiredOnboarding411'
  }, {
    questionKey: 'marketing.whatSupport411',
    getPassedInOptions: () => ({
      communityHref: getCommunityUrlPublic(),
      academyHref: getAcademyUrlPublic(),
      kbHref: getKnowledgeBaseUrlPublic(),
      langHref: getLanguagesUrlPublic(),
      onLinkClick: url => {
        trackEvent(getClickedLinkEvent({
          value: 'marketing.whatSupport411',
          url,
          type: 'external',
          location: LOCATIONS.FAQ
        }));
      }
    })
  }, {
    questionKey: 'marketing.whatDiscounts411',
    getPassedInOptions: () => ({
      startupsHref: getStartupsUrlPublic('pricing-marketingpage'),
      nonprofitsHref: getNonprofitsUrlPublic('pricing-marketingpage'),
      onLinkClick: url => {
        trackEvent(getClickedLinkEvent({
          value: 'marketing.whatDiscounts411',
          url,
          type: 'external',
          location: LOCATIONS.FAQ
        }));
      }
    })
  }, {
    questionKey: 'marketing.whenEligibleForNewPricing'
  }],
  [NavItemEnum.SALES]: [{
    questionKey: 'sales.whatIsSalesHub411',
    getHref: () => getSalesUrlPublic()
  }, {
    questionKey: 'sales.whatIsFreeVsPaid411'
  }, {
    questionKey: 'sales.howManyUsers411',
    isExternalLink: false,
    getHref: () => {
      return getCreateABundleUrl(false);
    }
  }, {
    questionKey: 'sales.salesVsService411'
  }, {
    questionKey: 'sales.whatSupport411',
    getPassedInOptions: () => ({
      communityHref: getCommunityUrlPublic(),
      academyHref: getAcademyUrlPublic(),
      kbHref: getKnowledgeBaseUrlPublic(),
      langHref: getLanguagesUrlPublic(),
      onLinkClick: url => {
        trackEvent(getClickedLinkEvent({
          value: 'sales.whatSupport411',
          url,
          type: 'external',
          location: LOCATIONS.FAQ
        }));
      }
    })
  }, {
    questionKey: 'sales.whatDiscounts411',
    getPassedInOptions: () => ({
      startupsHref: getStartupsUrlPublic('pricing-marketingpage'),
      nonprofitsHref: getNonprofitsUrlPublic('pricing-marketingpage'),
      onLinkClick: url => {
        trackEvent(getClickedLinkEvent({
          value: 'sales.whatDiscounts411',
          url,
          type: 'external',
          location: LOCATIONS.FAQ
        }));
      }
    })
  }, {
    questionKey: 'sales.whenEligibleForNewPricing'
  }],
  [NavItemEnum.SERVICE]: [{
    questionKey: 'service.whatIsServiceHub411',
    getHref: () => getServiceUrlPublic()
  }, {
    questionKey: 'service.whatIsFreeVsPaid411'
  }, {
    questionKey: 'service.howManyUsers411',
    isExternalLink: false,
    getHref: () => {
      return getCreateABundleUrl(false);
    }
  }, {
    questionKey: 'service.salesVsService411'
  }, {
    questionKey: 'service.whatSupport411',
    getPassedInOptions: () => ({
      communityHref: getCommunityUrlPublic(),
      academyHref: getAcademyUrlPublic(),
      kbHref: getKnowledgeBaseUrlPublic(),
      langHref: getLanguagesUrlPublic(),
      onLinkClick: url => {
        trackEvent(getClickedLinkEvent({
          value: 'service.whatSupport411',
          url,
          type: 'external',
          location: LOCATIONS.FAQ
        }));
      }
    })
  }, {
    questionKey: 'service.whatDiscounts411',
    getPassedInOptions: () => ({
      startupsHref: getStartupsUrlPublic('pricing-marketingpage'),
      nonprofitsHref: getNonprofitsUrlPublic('pricing-marketingpage'),
      onLinkClick: url => {
        trackEvent(getClickedLinkEvent({
          value: 'service.whatDiscounts411',
          url,
          type: 'external',
          location: LOCATIONS.FAQ
        }));
      }
    })
  }, {
    questionKey: 'service.whenEligibleForNewPricing'
  }],
  [NavItemEnum.CMS]: [{
    questionKey: 'cmsHub.whatIsCMSHub411',
    getHref: () => getMarketingUrlPublic()
  }, {
    questionKey: 'cmsHub.whatSupport411',
    getPassedInOptions: () => ({
      communityHref: getCommunityUrlPublic(),
      academyHref: getAcademyUrlPublic(),
      kbHref: getKnowledgeBaseUrlPublic(),
      langHref: getLanguagesUrlPublic(),
      onLinkClick: url => {
        trackEvent(getClickedLinkEvent({
          value: 'cmsHub.whatSupport411',
          url,
          type: 'external',
          location: LOCATIONS.FAQ
        }));
      }
    })
  }, {
    questionKey: 'cmsHub.whatLimits411',
    getHref: () => getProductAndServicesUrlPublic()
  }, {
    questionKey: 'cmsHub.whatDiscounts411',
    getPassedInOptions: () => ({
      startupsHref: getStartupsUrlPublic('pricing-marketingpage'),
      nonprofitsHref: getNonprofitsUrlPublic('pricing-marketingpage'),
      onLinkClick: url => {
        trackEvent(getClickedLinkEvent({
          value: 'cmsHub.whatDiscounts411',
          url,
          type: 'external',
          location: LOCATIONS.FAQ
        }));
      }
    })
  }],
  [NavItemEnum.OPERATIONS]: [{
    questionKey: 'operations.whatIsOperationsHub',
    getHref: () => getOperationsUrlPublic()
  }, {
    questionKey: 'operations.whatSupport',
    getPassedInOptions: () => ({
      communityHref: getCommunityUrlPublic(),
      academyHref: getAcademyUrlPublic(),
      kbHref: getKnowledgeBaseUrlPublic(),
      langHref: getLanguagesUrlPublic(),
      onLinkClick: url => {
        trackEvent(getClickedLinkEvent({
          value: 'operations.whatSupport',
          url,
          type: 'external',
          location: LOCATIONS.FAQ
        }));
      }
    })
  }, {
    questionKey: 'operations.whatDoesDataSyncDo',
    isJSX: false
  }, {
    questionKey: 'operations.whatTypeOfDataSync',
    getHref: () => getOperationsSupportedApplicationsUrl()
  }, {
    questionKey: 'operations.whatApplicationsSync',
    getHref: () => getOperationsSupportedApplicationsUrl()
  }, {
    questionKey: 'operations.whatIsProgrammableAutomation',
    isJSX: false
  }, {
    questionKey: 'operations.whatDiscounts411',
    getPassedInOptions: () => ({
      startupsHref: getStartupsUrlPublic('pricing-marketingpage'),
      nonprofitsHref: getNonprofitsUrlPublic('pricing-marketingpage'),
      onLinkClick: url => {
        trackEvent(getClickedLinkEvent({
          value: 'operations.whatDiscounts411',
          url,
          type: 'external',
          location: LOCATIONS.FAQ
        }));
      }
    })
  }, {
    questionKey: 'operations.whenEligibleForNewPricing'
  }],
  [NavItemEnum.FREE]: [{
    questionKey: 'free.whatAreLimits411',
    getHref: () => getProductAndServicesUrlPublic()
  }, {
    questionKey: 'free.emailIntegration411'
  }, {
    questionKey: 'free.howManyContacts411'
  }, {
    questionKey: 'free.whatSupport411',
    getPassedInOptions: () => ({
      communityHref: getCommunityUrlPublic(),
      academyHref: getAcademyUrlPublic(),
      kbHref: getKnowledgeBaseUrlPublic(),
      langHref: getLanguagesUrlPublic(),
      onLinkClick: url => {
        trackEvent(getClickedLinkEvent({
          value: 'free.whatSupport411',
          url,
          type: 'external',
          location: LOCATIONS.FAQ
        }));
      }
    })
  }, {
    questionKey: 'free.whatDiscounts411',
    getPassedInOptions: () => ({
      startupsHref: getStartupsUrlPublic('pricing-marketingpage'),
      nonprofitsHref: getNonprofitsUrlPublic('pricing-marketingpage'),
      onLinkClick: url => {
        trackEvent(getClickedLinkEvent({
          value: 'free.whatDiscounts411',
          url,
          type: 'external',
          location: LOCATIONS.FAQ
        }));
      }
    })
  }, {
    questionKey: 'free.whenEligibleForNewPricing'
  }],
  [NavItemEnum.SUITE]: [{
    questionKey: 'crmSuite.whatIsCrmSuite',
    isExternalLink: false,
    getHref: () => {
      return getCreateABundleUrl(false);
    }
  }, {
    questionKey: 'crmSuite.whenEligibleForNewPricing'
  }],
  [NavItemEnum.COMMERCE]: [{
    questionKey: 'commerce.whatIsCommerceHub'
  }, {
    questionKey: 'commerce.saasSubscription',
    getPassedInOptions: () => ({
      pAndSCatalogHref: getProductsAndServicesCatalogUrl(),
      onLinkClick: url => {
        trackEvent(getClickedLinkEvent({
          value: 'commerce.saasSubscription',
          url,
          type: 'external',
          location: LOCATIONS.FAQ
        }));
      },
      commercePricingPageHref: getCommerceUrlPublic()
    })
  }, {
    questionKey: 'commerce.doINeedASubscription',
    getPassedInOptions: () => ({
      pAndSCatalogHref: getProductsAndServicesCatalogUrl(),
      onCatalogLinkClick: () => {
        trackEvent(getClickedLinkEvent({
          value: 'commerce.doINeedASubscription',
          url: getProductsAndServicesCatalogUrl(),
          type: 'external',
          location: LOCATIONS.FAQ
        }));
      }
    })
  }, {
    questionKey: 'commerce.countryAvailability',
    getPassedInOptions: () => ({
      stripeAvailability: STRIPE_GLOBAL_AVAILABILITY_URL,
      onClickStripeAvailability: () => {
        trackEvent(getClickedLinkEvent({
          value: 'commerce.countryAvailability',
          url: STRIPE_GLOBAL_AVAILABILITY_URL,
          type: 'external',
          location: LOCATIONS.FAQ
        }));
      }
    })
  }, {
    questionKey: 'commerce.stripeVsHubSpotPayments'
  }, {
    questionKey: 'commerce.whichCurrencies',
    getPassedInOptions: () => ({
      stripeCurreciesUrl: getKBStripeCurrencyUrlPublic(),
      onClickStripeCurrencies: () => {
        trackEvent(getClickedLinkEvent({
          value: 'commerce.whichCurrencies',
          url: getKBStripeCurrencyUrlPublic(),
          type: 'external',
          location: LOCATIONS.FAQ
        }));
      }
    })
  }, {
    questionKey: 'commerce.stripeRateNegotiation',
    getPassedInOptions: () => ({
      stripeSupportUrl: STRIPE_SUPPORT_URL,
      onClickStripeSupport: () => {
        trackEvent(getClickedLinkEvent({
          value: 'commerce.stripeRateNegotiation',
          url: STRIPE_SUPPORT_URL,
          type: 'external',
          location: LOCATIONS.FAQ
        }));
      }
    })
  }, {
    questionKey: 'commerce.integratingIntoExistingSystem'
  }],
  [NavItemEnum.CONTENT]: [{
    questionKey: 'content.whatIsContentHub',
    getHref: () => getCMSUrlPublic(true)
  }, {
    questionKey: 'content.existingWebsite',
    getPassedInOptions: () => ({
      appMarketPlaceHref: getAppMarketplaceUrl(),
      shareFormsHref: getKBShareFormsUrlPublic(),
      embedCTAHref: getKBEmbedCTAUrlPublic(),
      trackingCodeHref: getKBTrackingCodeUrlPublic(),
      onLinkClick: url => {
        trackEvent(getClickedLinkEvent({
          value: 'content.existingWebsite',
          url,
          type: 'external',
          location: LOCATIONS.FAQ
        }));
      }
    })
  }, {
    questionKey: 'content.micrositeCustomPortal',
    getPassedInOptions: () => ({
      websiteBuilderHref: getCMSUrlPublic(true),
      micrositesExamplesHref: getMicrositesExamplesUrl(),
      membershipsHref: getKBMembershipsUrlPublic(),
      membershipsExamplesHref: getMembershipsExamplesUrl(),
      onLinkClick: url => {
        trackEvent(getClickedLinkEvent({
          value: 'content.micrositeCustomPortal',
          url,
          type: 'external',
          location: LOCATIONS.FAQ
        }));
      }
    })
  }, {
    questionKey: 'content.trainDevelopersAndIT',
    getPassedInOptions: () => ({
      quickStartHref: getDevelopersQuickStartGuideUrl(),
      apiHref: getDevelopersAndApiDocsBaseUrl(),
      hostingAndSecurityHref: getSecurityAndComplianceUrl(),
      onLinkClick: url => {
        trackEvent(getClickedLinkEvent({
          value: 'content.trainDevelopersAndIT',
          url,
          type: 'external',
          location: LOCATIONS.FAQ
        }));
      }
    })
  }, {
    questionKey: 'content.migrateExistingWebsite',
    getPassedInOptions: () => ({
      templatesHref: getTemplatesMarketplaceUrl(),
      importToolHref: getKBImportToolUrlPublic(),
      quickStartHref: getDevelopersQuickStartGuideUrl(),
      apiDocsHref: getDevelopersApiDocsUrl(),
      solutionsPartnerHref: getSolutionsMarketplaceUrl(),
      websiteMigrationHref: getWebsiteMigrationUrlPublic(),
      onLinkClick: url => {
        trackEvent(getClickedLinkEvent({
          value: 'content.migrateExistingWebsite',
          url,
          type: 'external',
          location: LOCATIONS.FAQ
        }));
      }
    })
  }, {
    questionKey: 'content.whatSupport',
    getPassedInOptions: () => ({
      langHref: getLanguagesUrlPublic(),
      communityHref: getCommunityUrlPublic(),
      academyHref: getAcademyUrlPublic(),
      kbHref: getKnowledgeBaseUrlPublic(),
      onLinkClick: url => {
        trackEvent(getClickedLinkEvent({
          value: 'content.whatSupport',
          url,
          type: 'external',
          location: LOCATIONS.FAQ
        }));
      }
    })
  }, {
    questionKey: 'content.whatDiscounts',
    getPassedInOptions: () => ({
      startupsHref: getStartupsUrlPublic('pricing-contentpage'),
      nonprofitsHref: getNonprofitsUrlPublic('pricing-contentpage'),
      onLinkClick: url => {
        trackEvent(getClickedLinkEvent({
          value: 'content.whatDiscounts',
          url,
          type: 'external',
          location: LOCATIONS.FAQ
        }));
      }
    })
  }, {
    questionKey: 'content.whenEligibleForNewPricing'
  }]
};